/* Bull Ring Fabrics: "Finish your project" upsell in the bag (2026-10-24, Abid). Loaded from snippets/brf-pdp-tidy.liquid.
   The cards come from sections/brf-upsell.liquid (/?section_id=brf-upsell), which picks linings and plain fabrics to go with
   the dress or curtain/upholstery fabrics in the bag. They are shown on the bag page (under the bag items), in the mobile
   bag drawer (under the items) and in the desktop bag popup (above the subtotal). "Add" puts the suggested length in the
   bag, the card ticks and the bag refreshes. A lining already in the bag stays on offer in its other colours (2026-10-24);
   a card only folds away once its last colour is in the bag. Styles: assets/brf-upsell.css.
   2026-10-24: after an Add from the desktop bag popup, the popup list is redrawn (window.brfBag.refresh in brf-c-header.js). */
(function () {
  if (window.__brfUpsell) return; window.__brfUpsell = 1;
  var doc = document, html = null, busy = false, again = false, timer = 0;
  var TICK = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';

  function slots() {
    var out = [], el;
    /* bag page: straight after the card holding the bag items */
    var card = doc.querySelector('.template-cart .cart-wrapper .container--flush > .card');
    if (card) out.push({ where: 'page', put: function (n) { if (card.nextElementSibling !== n) card.parentNode.insertBefore(n, card.nextElementSibling); } });
    /* mobile / side bag drawer: at the end of the scrolling item list, so it scrolls with the items */
    el = doc.querySelector('#mini-cart .mini-cart__line-item-list');
    if (el && el.querySelector('.mini-cart__line-item')) {
      var box = el;
      out.push({ where: 'drawer', put: function (n) { if (box.lastElementChild !== n) box.appendChild(n); } });
    }
    /* desktop glass-header bag popup: above the subtotal */
    el = doc.querySelector('#brf-hc-bag .brf-hc__bag-sub');
    if (el) {
      var sub = el;
      out.push({ where: 'pop', put: function (n) { if (sub.previousElementSibling !== n) sub.parentNode.insertBefore(n, sub); } });
    }
    return out;
  }

  function paint() {
    var s = slots();
    for (var i = 0; i < s.length; i++) {
      var w = s[i].where, cur = doc.querySelector('.brf-up[data-where="' + w + '"]');
      if (!html) { if (cur) cur.remove(); continue; }
      if (cur && cur.__src === html) { s[i].put(cur); continue; }
      var t = doc.createElement('div'); t.innerHTML = html;
      var n = t.firstElementChild; n.setAttribute('data-where', w); n.__src = html;
      if (cur) cur.remove();
      s[i].put(n); setup(n);
    }
    /* drop any card set left in a slot that went away */
    var all = doc.querySelectorAll('.brf-up[data-where]');
    for (var j = 0; j < all.length; j++) if (all[j].__src !== html) all[j].remove();
  }

  function load() {
    if (busy) { again = true; return; }
    busy = true;
    fetch((window.routes && routes.rootUrl || '/') + '?section_id=brf-upsell', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        var d = doc.createElement('div'); d.innerHTML = t;
        var n = d.querySelector('[data-brf-up]');
        html = n ? n.outerHTML : null;
        paint();
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; load(); } });
  }
  function soon() { clearTimeout(timer); timer = setTimeout(load, 250); }

  function maxOf(card) {
    var v = card.querySelector('[data-v]'), o = v && v.tagName === 'SELECT' ? v.options[v.selectedIndex] : v;
    var m = o && o.getAttribute('data-max');
    return m === '' || m == null ? Infinity : parseInt(m, 10);
  }
  function label(card) {
    var q = Math.max(1, Math.min(parseInt(card.getAttribute('data-q'), 10) || 1, maxOf(card)));
    card.__q = q;
    var b = card.querySelector('[data-add]');
    if (b && !b.classList.contains('is-done')) b.innerHTML = 'Add <span>' + q + '&nbsp;m</span>';
  }
  function setup(root) {
    var cards = root.querySelectorAll('.brf-up__c');
    for (var i = 0; i < cards.length; i++) label(cards[i]);
  }

  doc.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('.brf-up select[data-v]'); if (!s) return;
    var card = s.closest('.brf-up__c'), o = s.options[s.selectedIndex];
    var pr = card.querySelector('[data-price]'); if (pr && o.getAttribute('data-price')) pr.textContent = o.getAttribute('data-price');
    var im = card.querySelector('[data-img]'), src = o.getAttribute('data-img');
    if (im && src) { im.style.opacity = '.35'; var pre = new Image(); pre.onload = pre.onerror = function () { im.src = src; im.style.opacity = ''; }; pre.src = src; }
    label(card);
  });

  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.brf-up [data-add]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.classList.contains('is-busy') || b.classList.contains('is-done')) return;
    var card = b.closest('.brf-up__c'), v = card.querySelector('[data-v]');
    var id = v.tagName === 'SELECT' ? v.value : v.getAttribute('data-value');
    var q = card.__q || 1;
    b.classList.add('is-busy'); b.innerHTML = '<i class="brf-up__spin"></i>';
    fetch((window.routes && routes.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: +id, quantity: q }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (r) {
        if (!r.ok) throw r.j;
        b.classList.remove('is-busy'); b.classList.add('is-done'); b.innerHTML = TICK + '<span>Added</span>';
        if (navigator.vibrate) try { navigator.vibrate(10); } catch (er) {}
        setTimeout(function () {
          /* a lining with more colours left stays (it comes back offering the next colour); the last colour folds away */
          if ((parseInt(card.getAttribute('data-left'), 10) || 1) > 1) return;
          card.classList.add('is-gone');
          /* hide the whole set when this was the last card, so it never leaves an empty box behind */
          var up = card.closest('.brf-up');
          if (up && !up.querySelector('.brf-up__c:not(.is-gone)')) up.classList.add('is-gone');
        }, 650);
        setTimeout(function () {
          if (doc.body.classList.contains('template-cart')) {
            /* the bag page has no live refresh for items added from elsewhere: reload it softly, keeping the scroll */
            try { sessionStorage.setItem('brfUpY', String(window.scrollY)); } catch (er) {}
            location.reload();
            return;
          }
          doc.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
          /* desktop bag popup: redraw its list so the new lining shows at the top (2026-10-24, Abid: it used to stay off the list) */
          if (window.brfBag && brfBag.refresh) brfBag.refresh(true);
        }, 900);
      })
      .catch(function (err) {
        b.classList.remove('is-busy');
        b.classList.add('is-err');
        b.textContent = (err && err.description && /stock|available|only/i.test(err.description)) ? 'Sold out' : 'Try again';
        setTimeout(function () { b.classList.remove('is-err'); label(card); }, 2200);
      });
  }, true);

  /* the bag page reloads after an add: put the shopper back where they were */
  try {
    var y = sessionStorage.getItem('brfUpY');
    if (y != null) { sessionStorage.removeItem('brfUpY'); window.addEventListener('load', function () { window.scrollTo(0, +y); }); }
  } catch (er) {}

  /* the bag page, the drawer and the popup redraw themselves whenever the bag changes: put the cards back at once
     (from the last copy) and fetch a fresh set in case the bag changed */
  var mo = new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var t = list[i].target;
      if (t.closest && t.closest('.brf-up')) continue;
      var hit = false;
      for (var k = 0; k < list[i].addedNodes.length; k++) { var a = list[i].addedNodes[k]; if (a.nodeType === 1 && !(a.classList && a.classList.contains('brf-up'))) { hit = true; break; } }
      if (!hit) for (var r = 0; r < list[i].removedNodes.length; r++) { var d = list[i].removedNodes[r]; if (d.nodeType === 1 && !(d.classList && d.classList.contains('brf-up'))) { hit = true; break; } }
      if (hit) { paint(); return; }
    }
  });
  function watch() {
    var targets = ['#mini-cart', '#brf-hc-bag', '.template-cart [data-section-type="cart"]'];
    for (var i = 0; i < targets.length; i++) {
      var el = doc.querySelector(targets[i]);
      if (el && !el.__brfUpW) { el.__brfUpW = 1; mo.observe(el, { childList: true, subtree: true }); }
    }
  }
  /* refetch the cards whenever the bag itself changes (add, change, update, clear), whoever changed it */
  var f0 = window.fetch;
  if (f0) window.fetch = function (u) {
    var p = f0.apply(this, arguments);
    try {
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { soon(); }, function () {});
    } catch (er) {}
    return p;
  };
  function start() { watch(); load(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', watch);
  doc.addEventListener('cart:rerendered', function () { watch(); soon(); }, true);
})();
